import React from 'react';

import cn from 'classnames';
import { useIntl } from 'react-intl';

import FranceAgeConfirmationOrchestrator from 'components/FranceAgeConfirmationOrchestrator';
import TabBarItem from 'components/TabBarItem';

import FullWidthContainer from 'containers/FullWidthContainer';

import { generateFaqLink } from 'helpers/faqLink';

import { useAuth } from 'hooks/useAuth';
import { useIsPWA } from 'hooks/useIsPWA';

import './style.scss';

interface IProps {
  className?: string;
}

const TabBar = ({ className }: IProps) => {
  const { isAuthenticated } = useAuth();
  const { isPWA, iOSSafari } = useIsPWA();

  return (
    <FullWidthContainer
      className={cn(
        'TabBar fixed bottom-0 z-banner w-content-max bg-soft-sensual-bg',
        className,
        {
          'h-tab-bar-pwa': isPWA && iOSSafari,
        },
      )}
    >
      <FranceAgeConfirmationOrchestrator modalDelay={4000} />
      <div className="TabBar__wrapper mb-[env(safe-area-inset-bottom)] h-16 flex items-center w-full">
        <TabBarItem
          activeIcon="Homesolid"
          icon="Homeline"
          text="components.TabBar.Home"
          to="/browse"
        />
        <TabBarItem
          activeIcon="Searchsolid"
          icon="Searchline"
          text="components.TabBar.explore"
          to={'/explore'}
          otherMatchingUrls={['/search', '/journeys']}
        />

        {isAuthenticated && <PlaylistsTabBarItem />}
        {!isAuthenticated && <FAQTabBarItem />}
        <TabBarItem
          activeIcon="Settingssolid"
          icon="Settingsline"
          text="components.TabBar.settings"
          to="/my-femtasy/account"
        />
      </div>
    </FullWidthContainer>
  );
};

export default TabBar;

const PlaylistsTabBarItem = () => (
  <TabBarItem
    activeIcon="Heartsolid"
    icon="Heartline"
    text="SM0123.Playlists.NavBar"
    to="/playlists"
  />
);

const FAQTabBarItem = () => {
  const { locale } = useIntl();

  return (
    <TabBarItem
      activeIcon="Heartsolid"
      icon="Questionline"
      text="components.TabBar.FAQs"
      to={generateFaqLink(locale)}
    />
  );
};
